import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closePopup } from '../../actions/uiActions'
import { deletePresentation } from '../../actions/presentationActions'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
class DeletePresentation extends React.Component {

    handleDeletePres = (event) => {
        event.preventDefault()
        this.props.deletePresentation(this.props.popupInfo)

    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        let pres = this.props.presentationList.find(x => x.id === parseInt(this.props.popupInfo, 10))
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'Delete this Presentation?'}
                {' '}
            </DialogTitle>
            <DialogContent>             
                    <div className="passwordResetbox">
                    <h5><br />{pres.name}<br /></h5>
                    <br/>
                        <button
                            className="btn"
                            onClick={this.handleDeletePres}
                        >
                            Delete
                  </button>
                    </div>

            </DialogContent>
        </Dialog>)
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        presentationList: state.presentations.present.presentationList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, deletePresentation }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeletePresentation)